module.exports = __webpack_public_path__ + "static/media/LV_Carousel.5f198511.jpg";